<div
  *ngIf="!!avgResponseTime; else empty"
  class="content"
>
  <span class="mobile">
    Avg. response time
  </span>
  <span
    *ngIf="responseTimeAdapterFunction(avgResponseTime) as responseTimeObj"
    class="align-middle phase-text-styling number-style"
  >
    <ng-container *ngIf="responseTimeObj.hiringManagerResponseTimeDays > 0">
      {{responseTimeObj.hiringManagerResponseTimeDays}}
      <span class="min-txt">d</span>
    </ng-container>
    <ng-container *ngIf="responseTimeObj.hiringManagerResponseTimeHours > 0">
      {{responseTimeObj.hiringManagerResponseTimeHours}}
      <span class="min-txt">h</span>
    </ng-container>
    <ng-container *ngIf="responseTimeObj.hiringManagerResponseTimeMinutes > 0">
      {{responseTimeObj.hiringManagerResponseTimeMinutes}}
      <span class="min-txt">min</span>
    </ng-container>
  </span>
</div>

<ng-template #empty>
  <div class="content">
    <span class="mobile">
      Avg. response time
    </span>
    <span class="align-middle phase-text-styling number-style">
      0
      <span class="min-txt">min</span>
    </span>
  </div>
</ng-template>
